import React from "react";
import * as c from "./ctaVideoButton.module.scss";
import classNames from "classnames";
import { Button } from "@components/shared";
import IconPlay from "@icons/iconPlay";
import WistiaVideoPopover from "@components/wistia/wistiaVideoPopover";

export default function CtaVideoButton({
  className,
  label,
  id,
  wistiaVideoId,
  style = "Button Primary",
  showIcon = null,
  trackedEventName = null,
}) {
  if (!wistiaVideoId || !label) {
    return null;
  }

  const styleMap = {
    "Button Primary": "full",
    "Button Secondary": "outline",
    Text: "text",
    Link: "link",
  };

  const buttonStyle = styleMap[style];
  const shouldStyleTextUnderlined = !showIcon && buttonStyle === "link";

  return (
    <>
      <WistiaVideoPopover
        className={classNames(className, c.container, c[buttonStyle])}
        wistiaVideoId={wistiaVideoId}
        trackedEventName={trackedEventName}
      >
        <Button
          id={id}
          className={classNames(className, c.button, c[buttonStyle], buttonStyle !== "link" && c.btnFull, {
            [c.textUnderline]: shouldStyleTextUnderlined,
          })}
          asHtmlButton
          variant={buttonStyle}
        >
          {!shouldStyleTextUnderlined && <IconPlay className={c.playIcon} />}
          {label}
        </Button>
      </WistiaVideoPopover>
    </>
  );
}
